<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- タイトル -->
    <div class="page-title">
      <i class="pi pi-search"> </i>
      <label class="name">官民連携チャットルーム</label>

      <a
        pButton
        href="https://future-city.go.jp/platform/inquire/#kanminrenkei-chatroom"
        class="p-button-text">
        官民連携チャットルームのよくある質問へ<span class="p-button-icon p-button-icon-right pi pi-angle-right" aria-hidden="true"></span>
      </a>
    </div>

    <!-- ガード文言 -->
    <p>
      ※各会員の投稿内容について、当プラットフォーム及び運営事務局(内閣府)が管理・保証するものではありません。
    </p>

    <div class="search-flex">
      <!-- 検索条件入力 -->
      <div class="search-form-area">
        <form
          [formGroup]="l101SearchForm"
          (ngSubmit)="getResultThreadDataList(true)"
        >
          文字列を入力して「<i class="pi pi-search"></i>」をクリック
          <div class="p-d-flex p-jc-between">
            <!-- 検索テキスト -->
            <div class="search-text">
              <input
                type="text"
                pInputText
                placeholder="タイトルで検索"
                formControlName="freeword"
              />
            </div>
            <!-- 検索ボタン -->
            <button
              pButton
              type="submit"
              icon="pi pi-search"
              class="button1 search-button"
              (click)="getResultThreadDataList(true)"
            ></button>
          </div>

          <!-- クリアボタン -->
          <p-button
            label="入力をクリアする"
            styleClass="p-button-link"
            (click)="resetSearchForm()"
          ></p-button>
        </form>

        <div class="post-button-container" *ngIf="loginUser && memberClassId != 3">
          <span class="button-description">新しい相談の書き込みもできます</span>
          <a
            pButton
            type="button"
            class="button1 post-button"
            [attr.href]="'/pages/platform/l301/new'" target="_blank"
          >
            <span class="button-title">相談を書き込む</span>
            <span class="button-subtitle">（スレッド作成）</span>
          </a>
        </div>

      </div>

      <!-- 結果表示 -->
      <div class="result-area">
        <!-- ページアンカー -->
        <a id="jump-top"></a>

        <p-dataView
          #table
          [value]="resultThreadDataList"
          [paginator]="true"
          [rows]="50"
          [lazy]="true"
          [totalRecords]="totalRecords"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{first}~{last}件表示({totalRecords}件中)"
          [rowsPerPageOptions]="[50, 100, 500, 1000]"
          emptyMessage="データが存在しません"
          layout="list"
          (onLazyLoad)="getResultThreadDataList(false, $event)"
          (onPage)="jumpTop()"
        >
          <!-- ヘッダー -->
          <ng-template pTemplate="header">
            <!-- 検索結果数 -->
            <div class="p-d-flex p-jc-between result-count-area">
              <div>
                <label class="count"> {{ totalRecords }} </label>
                件（総件数：{{ countThreadData }}件） のスレッド
              </div>
            </div>
          </ng-template>
          <!-- リスト -->
          <ng-template
            let-resultThreadData
            pTemplate="listItem"
            let-rowIndex="rowIndex"
          >
            <!-- リスト表示 -->
            <p-table
              [value]="[{}]"
              selectionMode="single"
              styleClass="list-area"
            >
              <ng-template pTemplate="body">
                <tr
                  class="list"
                >
                  <td
                    class="title"
                  >
                    <a [attr.href]="'/pages/platform/l201/' + resultThreadData.thread_id" target="_blank">
                      {{ resultThreadData.title }}
                    </a>
                  </td>
                  <td class="organization-name">
                    <a [attr.href]="'/pages/platform/l201/' + resultThreadData.thread_id" target="_blank">
                      <span>新着{{resultThreadData.post_count_since_last_view }} (全{{ resultThreadData.post_count }}件)</span>
                    </a>
                  </td>
                  <td class="organization-name">
                    <a [attr.href]="'/pages/platform/l201/' + resultThreadData.thread_id" target="_blank">
                      {{getDisplayName(resultThreadData)}}
                    </a>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </ng-template>
        </p-dataView>

      </div>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
